import API, { baseURL } from './api';
import { getSucursalInfo } from './auth';

export async function getAttendanceRoster({ classId, date, sucursalId }) {
  const id = sucursalId || getSucursalInfo()?.id || 1;
  return API.get(`${baseURL}api/student-attendance/${id}`, { params: { classId, date } });
}

export async function saveAttendance({ classId, className, date, records, markedBy, sucursalId }) {
  const id = sucursalId || getSucursalInfo()?.id || 1;
  return API.post(`${baseURL}api/student-attendance/bulk`, {
    sucursalId: id,
    classId,
    className,
    date,
    markedBy,
    records,
  });
}

export async function printAttendance({ classId, date, sucursalId }) {
  const id = sucursalId || getSucursalInfo()?.id || 1;
  return API.get(`${baseURL}api/student-attendance/print/${classId}`, { params: { sucursalId: id, date } });
}
